import { render, staticRenderFns } from "./linkBlock.vue?vue&type=template&id=5dd789ad&scoped=true"
import script from "./linkBlock.vue?vue&type=script&lang=js"
export * from "./linkBlock.vue?vue&type=script&lang=js"
import style0 from "./linkBlock.vue?vue&type=style&index=0&id=5dd789ad&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd789ad",
  null
  
)

export default component.exports